import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    service: null,
    services: [],
    servicesTotal: 0,
    orderCreatedService: null,
  },

  getters: {
    service(state) {
      return state.service
    },
    services(state) {
      return state.services
    },
    servicesTotal(state) {
      return state.servicesTotal
    },
  },

  mutations: {
    SET_SERVICE(state, value) {
      state.service = value
    },
    SET_SERVICES(state, value) {
      state.services = value
    },
    SET_SERVICES_TOTAL(state, value) {
      state.servicesTotal = Number(value) || 0
    },
    UPDATE_SERVICES(state, data) {
      const index = state.services.findIndex((service) => service.id == data.id)
      if (index === -1) {
        return
      }
      Object.assign(state.services[index], data)
    },
    ADD_SERVICE(state, data) {
      state.services.unshift(data)
      state.servicesTotal += 1
    },
    DELETE_SERVICE(state, id) {
      const index = state.services.findIndex((service) => Number(service.id) === Number(id))
      if (index !== -1) {
        state.services.splice(index, 1)
        if (state.servicesTotal > 0) {
          state.servicesTotal -= 1
        }
      }
    },
    SET_ORDER_CREATED_SERVICE(state, service) {
      state.orderCreatedService = service
    },
  },

  actions: {
    async loadService({ commit }, serviceId) {
      const response = await axios.get(`api/services/${serviceId}`)
      commit('SET_SERVICE', response.data)
      return response.data
    },
    loadServices({ commit }, filters = {}) {
      const params = {}
      if (filters.keyword) {
        params.keyword = filters.keyword
      }
      if (filters.service_category_id) {
        params.service_category_id = filters.service_category_id
      }
      if (filters.page) {
        params.page = filters.page
      }
      if (filters.per_page) {
        params.per_page = filters.per_page
      }

      return axios.get('api/services', { params }).then((response) => {
        const data = response.data.data || []
        const total = Number(response.data.meta?.total ?? data.length)
        commit('SET_SERVICES', data)
        commit('SET_SERVICES_TOTAL', total)
        return { data, total }
      })
    },
    updateService({ commit }, { formData }) {
      return axios
        .post(`api/services/${formData.get('id')}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          commit('UPDATE_SERVICES', response.data.data)
        })
    },
    searchService(_, keyword) {
      return axios
        .post('api/services/search', { keyword })
        .then((response) => response.data)
    },
    addService({ commit }, { formData }) {
      return axios
        .post('api/services', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          commit('ADD_SERVICE', response.data.data)
          return response.data.data
        })
    },
    deleteService({ commit }, id) {
      return axios.delete(`api/services/${id}`).then(() => {
        commit('DELETE_SERVICE', id)
      })
    },
  },
}
